<section class="circle-gradient-1">
    <div class="circle-gradient overflow-hidden">
        <div class="breadcrumb-sec event-sec">
            <div class="container">
                <div class="row g-0">
                    <div class="col-lg-6 col-md-6">
                        <ul class="breadcrumb">
                            <li><a routerLink="/">Home</a></li>
                            <li><i class="fa fa-angle-right"></i></li>
                            <li><a href="events">Events</a></li>
                            <li><i class="fa fa-angle-right"></i></li>
                            <li> Induction Program</li>
                        </ul>
                        <div class="sec-title">
                            <h1><span> Induction Program</span></h1>
                            <p>GHRCACS celebrated Founder's Day by organizing a Debate Competition for students on 30th
                                June
                                2025.
                            </p>

                        </div>
                        <div class="breadcrumb-overlay overflow-hidden"
                            style="background-image: url(https://rgicdn.s3.ap-south-1.amazonaws.com/ghrcacs/images/events/induction-program2.webp);">
                        </div>

                    </div>
                </div>
            </div>
        </div>
    </div>
</section>
<section class="circle-gradient-1">
    <div class="container">


        <div class="section-lg">
            <div class="sec-title text-center">
                <h2><span>Photo Gallery</span></h2>
            </div>
            <div class="demo-gallery">
                <ul  appLightgallery>
                    <li class="grid-item1"
                        data-responsive="https://rgicdn.s3.ap-south-1.amazonaws.com/ghrcacs/images/events/induction-program.webp"
                        data-src="https://rgicdn.s3.ap-south-1.amazonaws.com/ghrcacs/images/events/induction-program.webp">
                        <a href="#">
                            <img class="img-fluid"
                                src="https://rgicdn.s3.ap-south-1.amazonaws.com/ghrcacs/images/events/induction-program.webp">
                        </a>
                    </li>
                    <li class="grid-item2"
                        data-responsive="https://rgicdn.s3.ap-south-1.amazonaws.com/ghrcacs/images/events/induction-program1.webp"
                        data-src="https://rgicdn.s3.ap-south-1.amazonaws.com/ghrcacs/images/events/induction-program1.webp">
                        <a href="#">
                            <img class="img-fluid"
                                src="https://rgicdn.s3.ap-south-1.amazonaws.com/ghrcacs/images/events/induction-program1.webp">
                        </a>
                    </li>
                    <li class="grid-item3 d-none d-lg-block d-md-block"
                        data-responsive="https://rgicdn.s3.ap-south-1.amazonaws.com/ghrcacs/images/events/induction-program2.webp"
                        data-src="https://rgicdn.s3.ap-south-1.amazonaws.com/ghrcacs/images/events/induction-program2.webp">
                        <a href="#">
                            <img class="img-fluid"
                                src="https://rgicdn.s3.ap-south-1.amazonaws.com/ghrcacs/images/events/induction-program2.webp">
                        </a>
                    </li>
                    <li class="grid-item4 "
                        data-responsive="https://rgicdn.s3.ap-south-1.amazonaws.com/ghrcacs/images/events/induction-program3.webp"
                        data-src="https://rgicdn.s3.ap-south-1.amazonaws.com/ghrcacs/images/events/induction-program3.webp">
                        <a href="#">
                            <img class="img-fluid"
                                src="https://rgicdn.s3.ap-south-1.amazonaws.com/ghrcacs/images/events/induction-program3.webp">
                        </a>
                    </li>
                    <li class="grid-item5 "
                        data-responsive="https://rgicdn.s3.ap-south-1.amazonaws.com/ghrcacs/images/events/induction-program4.webp"
                        data-src="https://rgicdn.s3.ap-south-1.amazonaws.com/ghrcacs/images/events/induction-program4.webp">
                        <a href="#">
                            <img class="img-fluid"
                                src="https://rgicdn.s3.ap-south-1.amazonaws.com/ghrcacs/images/events/induction-program4.webp">
                        </a>
                    </li>
                    <li class="grid-item6 d-none d-lg-block d-md-block"
                        data-responsive="https://rgicdn.s3.ap-south-1.amazonaws.com/ghrcacs/images/events/induction-program5.webp"
                        data-src="https://rgicdn.s3.ap-south-1.amazonaws.com/ghrcacs/images/events/induction-program5.webp">
                        <a href="#">
                            <img class="img-fluid"
                                src="https://rgicdn.s3.ap-south-1.amazonaws.com/ghrcacs/images/events/induction-program5.webp">
                        </a>
                    </li>
                </ul>
            </div>
        </div>

    </div>
</section>
